import { imageBaseUrl } from 'api';

export const imagePath = imgPath => {
  if (!imagePath) return null;
  const src = `${imageBaseUrl}/${imgPath}`;
  return src;
};
